/**
 * Filtros tipo Excel: cada dimensión acota a las demás (AND).
 * Grupo ↔ vendedor (miembros). Grupo ↔ campaña (campaign.group_id).
 */

export function memberIdsOfGroup(group) {
  if (!group) return [];
  const members = group.members || [];
  if (members.length) {
    return members.map((m) => m.vendor_id || m.id).filter(Boolean);
  }
  return (group.vendor_ids || []).filter(Boolean);
}

export function vendorsVisibleForGroup(vendors, groups, groupId) {
  const list = Array.isArray(vendors) ? vendors : [];
  if (!groupId || groupId === 'all') return list;
  const g = (groups || []).find((x) => x.id === groupId);
  const ids = new Set(memberIdsOfGroup(g));
  return list.filter((v) => ids.has(v.id));
}

export function groupsVisibleForVendor(groups, sellerId) {
  const list = Array.isArray(groups) ? groups : [];
  if (!sellerId || sellerId === 'all') return list;
  return list.filter((g) => memberIdsOfGroup(g).includes(sellerId));
}

/** Campañas de ESE grupo (campaign.group_id). Sin grupo en la campaña = no es de otro grupo, se queda. */
export function campaignsVisibleForGroup(campaigns, groupId) {
  const list = Array.isArray(campaigns) ? campaigns : [];
  if (!groupId || groupId === 'all') return list;
  return list.filter((c) => (c.group_id || '') === groupId);
}

export function groupsVisibleForCampaign(groups, campaigns, campaignId) {
  const list = Array.isArray(groups) ? groups : [];
  if (!campaignId || campaignId === 'all') return list;
  const camp = (campaigns || []).find((c) => c.id === campaignId);
  if (!camp?.group_id) return list;
  return list.filter((g) => g.id === camp.group_id);
}

export function reconcileSellerGroup(filters, groups, patch) {
  const next = { ...filters, ...patch };
  const seller = next.seller_id || next.assigned_to || 'all';
  const groupId = next.group_id || 'all';
  if (seller !== 'all' && groupId !== 'all') {
    const g = (groups || []).find((x) => x.id === groupId);
    if (!memberIdsOfGroup(g).includes(seller)) {
      if (Object.prototype.hasOwnProperty.call(patch, 'group_id')) {
        next.seller_id = 'all';
        if ('assigned_to' in next) next.assigned_to = 'all';
      } else {
        next.group_id = 'all';
      }
    }
  }
  return next;
}

export function reconcileFilters(filters, groups, campaigns, patch) {
  const next = reconcileSellerGroup(filters, groups, patch);
  const campId = next.campaign_id || 'all';
  const groupId = next.group_id || 'all';
  if (campId !== 'all' && groupId !== 'all') {
    const camp = (campaigns || []).find((c) => c.id === campId);
    if (camp?.group_id && camp.group_id !== groupId) {
      if (Object.prototype.hasOwnProperty.call(patch, 'group_id')) {
        next.campaign_id = 'all';
      } else if (Object.prototype.hasOwnProperty.call(patch, 'campaign_id')) {
        next.group_id = camp.group_id;
      }
    }
  }
  return next;
}

export function byFacet(items, facetIds, selectedId) {
  const list = Array.isArray(items) ? items : [];
  if (!Array.isArray(facetIds)) return list;
  const allow = new Set(facetIds.filter(Boolean));
  if (selectedId && selectedId !== 'all') allow.add(selectedId);
  return list.filter((i) => allow.has(i.id));
}

export function idsOf(items, pick) {
  const out = new Set();
  (items || []).forEach((row) => {
    const v = typeof pick === 'function' ? pick(row) : row?.[pick];
    if (Array.isArray(v)) v.forEach((x) => x && out.add(x));
    else if (v) out.add(v);
  });
  return [...out];
}
